import React from 'react';
import axios from 'axios';
import qs from 'qs';

React.Component.prototype.$http = axios;
React.Component.prototype.$qs = qs;

axios.defaults.baseURL = '/api';
// 设置请求时间
// axios.defaults.timeout = 15000;
// 请求拦截器
axios.interceptors.request.use(function (config) {
    //获取token
    const token = localStorage.getItem("Token")
    //每次请求传递token
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
// 响应请求拦截器
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});